export class TimeEntity {
  time: number = 0
  deltaTime: number = 0
  unscaledTime: number = 0
  unscaledDeltaTime: number = 0
}
